import { z } from 'zod'
import {
  FREITEXT_SHORT_REGEXP,
  FREITEXT_SHORT_MAX_LENGTH
} from '../../../../utils'
import { allowedChars } from '../../../../utils/customValidationMessage'

// Default constants
const DEFAULT_AUFTRAG_32_10 = {
  enabled: true,
  signalUsw: ''
}

const DEFAULT_BEFEHL_32_FORM = {
  auftrag_32_10: DEFAULT_AUFTRAG_32_10
}

// Schema definitions
const Auftrag32_10Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_32_10.enabled),
    signalUsw: z
      .string()
      .max(FREITEXT_SHORT_MAX_LENGTH)
      .superRefine(allowedChars(FREITEXT_SHORT_REGEXP))
      .default(DEFAULT_AUFTRAG_32_10.signalUsw)
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_32_10))

// Base schema
const Befehl32FormSchemaBase = z
  .object({
    auftrag_32_10: Auftrag32_10Schema
  })
  .default(() => structuredClone(DEFAULT_BEFEHL_32_FORM))

export const Befehl32FormSchema = Befehl32FormSchemaBase

// Validation schema factory
export const createBefehl32FormValidationSchema = () => {
  return Befehl32FormSchemaBase
}

export type Befehl32FormData = z.infer<typeof Befehl32FormSchemaBase>
